import React from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';

import { SubmittalsItemDisplay } from './common';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { ACTIVITY_VARIANTS } from '../../constants';
import { useTranslation } from '../i18n';
import { SubmittalsItem } from '../types';

const SubmittalsActivityCard: Exclude<
  ReferencePickerPlugin<SubmittalsItem>['ActivityCard'],
  undefined
> = ({ entity, variant, ...rest }) => {
  const { t } = useTranslation();

  const title =
    variant === ACTIVITY_VARIANTS.ADDED
      ? t('ACTIVITY_CARD_TITLE_ADD')
      : t('ACTIVITY_CARD_TITLE_REMOVE');

  return (
    <ActivityCard {...rest} title={title}>
      <SubmittalsItemDisplay item={entity} />
    </ActivityCard>
  );
};

export default SubmittalsActivityCard;
